const getters = {
    getDockSuggestions: (state) => {
        console.log("Dock suggestiosn", state.dockSuggestions)
        return _.orderBy(state.dockSuggestions, ['estimatedTime'], 'asc');
    },
}

export default getters